import { axios as oriService } from '../axiosService';
import { BASE_URL } from './index';
import { getSessionStorage } from '@utils/windowUtil';

const RequestManager = {
  currentId: getSessionStorage('currentId'),
  currentController: getSessionStorage('currentId')
    ? new AbortController()
    : null,
  changeCurReqId: (projectId) => {
    if (RequestManager.currentId === projectId) {
      return;
    }
    if (RequestManager.currentController instanceof AbortController) {
      RequestManager.currentController.abort();
    }

    RequestManager.currentId = projectId;

    if (!projectId) {
      RequestManager.currentController = null;
      return;
    }
    RequestManager.currentController = new AbortController();
  },
  applySignal: (axiosConfig) => {
    if (!RequestManager.currentId || !RequestManager.currentController) {
      return axiosConfig;
    }
    return { ...axiosConfig, signal: RequestManager.currentController.signal };
  },
};

const service = new Proxy(oriService, {
  get: (obj, prop) => {
    const value = Reflect.get(obj, prop);
    if (typeof value !== 'function') {
      return Reflect.get(obj, prop);
    }
    return function (...args) {
      if (['get', 'delete'].includes(prop)) {
        const [url, config = {}] = args;
        return value.apply(obj, [url, RequestManager.applySignal(config)]);
      }
      const [url, data, config] = args;
      return value.apply(obj, [url, data, RequestManager.applySignal(config)]);
    };
  },
});

export const getProjectSetting = (projectId) =>
  service
    .get(`${BASE_URL}/project/settings/${projectId}`)
    .then((res) => res || null);

export const ProjectInfoRequestManager = RequestManager;
